import { getLocalizedMessage, isCorrectData, loadConfig, saveConfig, showMessageAlert } from '@/core/shared'
import { getResourceFileLink } from '@/core/migration/supportMigrationFunctions'
import { Progress } from '@/core/input_controls/fileUploader/imageUploader'
import { resizeTableHeight } from '@/core/support_gui_components/table/table'

export function ImportManager () {
	this.importHistory = []
	this.importConfigs = []

	this.getImportHistory = function () {
		return this.importHistory
	}

	this.getDataFileMaskByImportType = function (importType) {
		return {
			'XML': '.xml',
			'EXCEL': '.xlsx',
			'CSV': '.csv',
			'ZIP_ATTACHMENT': '.zip'
		}[importType]
	}

	this.findConfig = function (id) {
		var config = undefined
		_.each(this.importConfigs, function (value, key) {
			if (String(value['id']) === String(id)) {
				config = value
			}
		})
		return config
	}

	this.setLastUseConfig = function (lastUseImportConfig) {
		if (lastUseImportConfig == null) {
			return
		}

		var id = lastUseImportConfig['id']
		var importConfig = this.findConfig(id)
		if (importConfig == null) {
			return
		}

		var importTypesSelect = $('#import-types')
		importTypesSelect.val(importConfig['type'])
		importTypesSelect.change()

		var importTemplatesSelect = $('#import-templates')
		importTemplatesSelect.val(importConfig['name'])
		importTemplatesSelect.change()
	}

	this.loadImportHistory = function () {
		var context = this
		$.ajax({
			url: window.urlContext + 'import',
			type: 'GET',
			async: false,
			context: this,
			success: function (data) {
				context.importHistory = data

				context.bindImportTypeChanges()
				context.bindImportTemplateChanges()

				importLauncher.launched = false
			}
		})
	}

	this.loadImportConfigs = function () {
		var context = this
		$.ajax({
			type: 'GET',
			url: window.urlContext + 'import-config',
			async: false,

			success: function (config) {
				context.importConfigs = config

				context.renderImportTypes()
				$('#import-types').change()
			}
		})
	}

	this.restoreLastState = function () {
		var lastUseImportConfig = loadConfig('import.lastUseConfig')
		this.setLastUseConfig(lastUseImportConfig)
	}

	this.renderImportTypes = function () {
		var types = []
		_.each(this.importConfigs, function (value, key) {
			var type = value['type']
			if (types.indexOf(type) === -1) {
				types.push(type)
			}
		})

		_.each(types, function (type, key) {
			$('#import-types').append('<option>' + type + '</option>')
		})
	}

	this.renderImportTemplate = function (importType) {
		$('#import-templates').empty()
		_.each(this.importConfigs, function (value, key) {
			if (value['type'] == importType) {
				$('#import-templates').append('<option data-id=\'' + value['id'] + '\'>' + value['name'] + '</option>')
			}
		})
	}

	this.bindImportTemplateChanges = function () {
		var context = this
		$('#import-templates').change(function () {
			var selectedOptionIndex = this.options['selectedIndex']
			var id = $(this.options[selectedOptionIndex]).attr('data-id')
			var config = context.findConfig(id)
			context.renderImportConfig(config)
		})
	}

	this.bindImportTypeChanges = function () {
		var context = this
		$('#import-types').change(function () {
			var selectedImportType = $('#import-types').val()
			context.renderImportTemplate(selectedImportType)

			var id = $('#import-templates option:selected').attr('data-id')

			var config = context.findConfig(id)
			context.renderImportConfig(config)
		})
	}

	this.renderImportConfig = function (config) {
		var dataFileMask = this.getDataFileMaskByImportType(config.type)
		$('#import-file').attr('accept', dataFileMask)

		$('#import-launcher').attr('data-config-id', config.id)

		var importSampleValue = ''
		var importSampleHref = ''

		var parameters = config['parameters']
		if (parameters['importSample'] == null) {
			if (config.type === 'EXCEL' && (parameters['xslt'] == null || parameters['xslt'].length === 0)) {
				importSampleValue = 'template_export.xlsx'
				importSampleHref = window.urlContext + 'export-config/excel/template/export'
			}
		} else {
			var resourceName = parameters['importSample']
			var link = getResourceFileLink(resourceName, false)

			importSampleValue = link.name
			importSampleHref = window.urlContext + link.url
		}

		$('#import-sample').attr('href', importSampleHref)
		$('#import-sample').html(importSampleValue)
	}

	this.checkAllImportSuccess = function (callback) {
		var importManager = this
		var oldCount = _.where(this.importHistory, { status: null }).length
		if (oldCount > 0) {
			var intervalId = setInterval(function () {
				importManager.loadImportHistory()
				var newCount = _.where(importManager.importHistory, { status: null }).length
				if (oldCount != newCount) {
					callback(importManager.importHistory)
					oldCount = newCount
				}
				if (newCount == 0) {
					clearInterval(intervalId)
				}
			}, 5000)
		}
	}

	this.resendImport = function (importId) {
		$.ajax({
			url: window.urlContext + 'import/' + importId + '/resend',
			cache: false,
			contentType: false,
			type: 'POST',

			success: function (data) {
				document.location.reload()
			},

			error: function () {
				showMessageAlert(getLocalizedMessage("error"), getLocalizedMessage('error.reimport'), 'danger');
			}
		})
	}
}

export var importLauncher = function () {
	function launch () {
		var importConfigId = $('#import-launcher').attr('data-config-id')
		importLauncher.launched = true
		var data = new FormData()
		var file = Array.from($('#import-file').get(0).files)[0]
		data.append('source', file)
		// $('#import-file').get(0).value = ''
		data.append('importConfigId', importConfigId)

		if (isCorrectData($('#import-file').val())) {
			$('#upload-import-progress').removeClass('hidden-element')
			resizeTableHeight()
			var progress = new Progress($('#upload-import-progress'))
			var xhr = $.ajaxSettings.xhr()

			$.ajax({
				url: window.urlContext + 'import',
				data: data,
				cache: false,
				contentType: false,
				processData: false,
				type: 'POST',

				xhr: function () {
					xhr.upload.addEventListener('progress', progress.progressHandlingFunction, false)
					return xhr
				},

				beforeSend: function () {
					progress.bindCancelButton(xhr, '.button_reset', function () {
						importLauncher.launched = false
						$('#upload-import-progress').addClass('hidden-element')
						resizeTableHeight()
					})
				},

				success: function (data) {
					document.location.reload()
				},
				error: function () {
					$('#upload-import-progress').addClass('hidden-element')
					resizeTableHeight()
					showMessageAlert(getLocalizedMessage("error"), getLocalizedMessage('error.loading.file'), 'danger');
					importLauncher.launched = false
				}
			})
			saveConfig('import.lastUseConfig', JSON.stringify({
				'id': importConfigId,
			}))
		} else {
			showMessageAlert(getLocalizedMessage("error"), 'danger');
			importLauncher.launched = false
			console.warn($('#import-file').val(), importConfigId)
		}
	}

	return {
		launchImport: function (importConfigId) {
			if (!this.launched) {
				launch(importConfigId)
			}
		}
	}

}()

export function getImportReport (id, status) {
	$.ajax({
		url: window.urlContext + 'import/report/get',
		type: 'POST',
		data: { importId: id },
		success: function (data) {
			if (status) {
				showMessageAlert(getLocalizedMessage('success'),'success', data);
			} else {
				showMessageAlert(getLocalizedMessage("error"),'danger', data);
			}
		},
		error: function (data) {
			showMessageAlert(getLocalizedMessage("error"), data.statusText, 'danger');
		}
	});
}
